import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/use-auth'
import { homePathForRole, postAuthPath } from '@/lib/auth'

export function HomeRedirect() {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream font-sans text-sm text-muted-foreground">
        Loading…
      </div>
    )
  }

  if (!user) return <Navigate to="/login" replace />
  if (user.requiresOnboarding) return <Navigate to="/complete-profile" replace />
  return <Navigate to={postAuthPath(user)} replace />
}

export function RoleFallbackRedirect() {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream font-sans text-sm text-muted-foreground">
        Loading…
      </div>
    )
  }

  if (!user) return <Navigate to="/login" replace />
  return <Navigate to={homePathForRole(user.role)} replace />
}
